import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { openItemsReducer } from "./reducer";
import {
  getAdminOpenItemsListAction,
  addAdminOpenItemsAction,
  getAdminOpenItemsSingleAction,
  getClientOpenItemsListAction,
  updateAdminOpenItemsAction,
  uploadClientOpenItemsAction,
  getAllOpenItemCommentsAction,
  addOpenItemCommentsAction,
  updateStatusAdminOpenItemsAction,
  sendOpenItemEmailAction
} from "./actions";
import { OpenItemsType } from "./openItemsTypes";

export const openItemsSlice = createSlice({
  name: 'openItems',
  initialState,
  reducers: openItemsReducer,
  extraReducers: {
    [updateAdminOpenItemsAction.pending.toString()]: (state: any) => ({
      ...state,
      fetching: true
    }),
    [updateAdminOpenItemsAction.fulfilled.toString()]: (state: any, { payload }) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      } else {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          // error: message
        }
      }
    },
    [updateAdminOpenItemsAction.rejected.toString()]: (state: any, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),

    [updateStatusAdminOpenItemsAction.pending.toString()]: (state: any) => ({
      ...state,
      fetching: true
    }),
    [updateStatusAdminOpenItemsAction.fulfilled.toString()]: (state, { payload }) => {
      const { success, status_code, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      } else {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          // error: message
        }
      }
    },
    [updateStatusAdminOpenItemsAction.rejected.toString()]: (state: any, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),

    [addAdminOpenItemsAction.pending.toString()]: (state: any) => ({
      ...state,
      fetching: true
    }),

    [addAdminOpenItemsAction.fulfilled.toString()]: (state: any, { payload }) => {

      const { message, status_code, data, success } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: 200,
          error: message
        }
      } else {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: 200,
          error: message
        }
      }
    },
    [addAdminOpenItemsAction.rejected.toString()]: (state: any, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message

    }),
    [getAdminOpenItemsSingleAction.pending.toString()]: (state: any) => ({
      ...state,
      fetching: true
    }),
    [getAdminOpenItemsSingleAction.fulfilled.toString()]: (state: any, { payload }) => {
      const { success, status_code, message, data } = payload
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,

        }
      }
      else {
        return {
          ...state,
          fetching: false,
          // success,
          statusCode: status_code,
          error: message,
          adminOpenItemSingle: data
        }
      }

    },
    [getAdminOpenItemsSingleAction.rejected.toString()]: (state: any, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),
    [getAdminOpenItemsListAction.pending.toString()]: (state: OpenItemsType) => ({
      ...state,
      fetching: true
    }),

    [getAdminOpenItemsListAction.fulfilled.toString()]: (state: OpenItemsType, { payload }) => {
      const { status_code, data, success, message } = payload;
      const { creator_open_item, manager_open_item } = data;


      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        adminOpenItemList: creator_open_item,
        sharedOpenItemsList: manager_open_item
      }
    },
    [getAdminOpenItemsListAction.rejected.toString()]: (state: OpenItemsType, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),
    [getClientOpenItemsListAction.pending.toString()]: (state: OpenItemsType) => ({
      ...state,
      fetching: true
    }),
    [getClientOpenItemsListAction.fulfilled.toString()]: (state: OpenItemsType, { payload }) => {
      const { status_code, data, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        clientOpenItemList: data
      }
    },
    [uploadClientOpenItemsAction.pending.toString()]: (state: OpenItemsType) => ({
      ...state,
      fetching: true
    }),
    [uploadClientOpenItemsAction.fulfilled.toString()]: (state: OpenItemsType, { payload }) => {
      const { status_code, data, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        success
      }
    },
    [uploadClientOpenItemsAction.rejected.toString()]: (state: OpenItemsType, { error }) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message
    }),
    [getAllOpenItemCommentsAction.pending.toString()]: (state: OpenItemsType) => ({
      ...state,
      commentsFetching: true
    }),
    [getAllOpenItemCommentsAction.fulfilled.toString()]: (state: OpenItemsType, { payload }) => {
      const { status_code, data, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          commentsFetching: false,
          success,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        commentsFetching: false,
        openItemsCommentsList: data
      }
    },
    [getAllOpenItemCommentsAction.rejected.toString()]: (state: OpenItemsType, { error }) => ({
      ...state,
      commentsFetching: false,
      success: 0,
      error: error?.message
    }),
    [addOpenItemCommentsAction.pending.toString()]: (state: OpenItemsType) => ({
      ...state,
      commentsFetching: true
    }),
    [addOpenItemCommentsAction.fulfilled.toString()]: (state: OpenItemsType, { payload }) => {
      const { status_code, data, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          commentsFetching: false,
          commentsSuccess: success,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        commentsFetching: false,
        commentsSuccess: success
      }
    },
    [addOpenItemCommentsAction.rejected.toString()]: (state: OpenItemsType, { error }) => ({
      ...state,
      commentsFetching: false,
      commentsSuccess: 0,
      error: error?.message
    }),
    [sendOpenItemEmailAction.pending.toString()]: (state: OpenItemsType) => ({
      ...state,
      fetching: true
    }),
    [sendOpenItemEmailAction.fulfilled.toString()]: (state: OpenItemsType, { payload }) => {
      const { status_code, data, success, message } = payload;

      if (success === 0) {
        return {
          ...state,
          emailSuccess: success,
          statusCode: status_code,
          error: message,
          fetching: false
        }
      }

      return {
        ...state,
        emailSuccess: success,
        fetching: false
      }
    },
    [sendOpenItemEmailAction.rejected.toString()]: (state: OpenItemsType, { error }) => ({
      ...state,
      fetching: false,
      emailSuccess: 0,
      error: error?.message
    })
  }
});

export const {
  resetError: resetOpenItemsError,
  resetSuccess: resetOpenItemsSuccess,
  resetOpenItemsFetching,
  resetAdminOpenItemsList,
  resetClientOpenItemsList,
  resetSingleOpenItem,
  resetOpenItemsCommentList,
  resetEmailSuccess
} = openItemsSlice.actions;